import type { IChannelHeader } from './types';

export class ChannelHeader implements IChannelHeader {
  label: string = '';
  transducer: string = '';
  physicalDimensions: string = '';
  physicalMin: number = 0;
  physicalMax: number = 0;
  digitalMin: number = 0; // gain 이 곱해져 있다.
  digitalMax: number = 0; // gain 이 곱해져 있다.
  preFiltering: string = '';
  samples: number = 0;
  reserved: string = '';

  get scaleFactor() {
    return (this.physicalMax - this.physicalMin) / (this.digitalMax - this.digitalMin);
  }
}

